var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('date-export',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentExportType === 'date'),expression:"currentExportType === 'date'"}],ref:"dateExport",on:{"event":_vm.handleEvent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }